import FileBlock from './base/file-block';
import BlockMutationResult from '../block-mutation-result';
import BlockRange from '../block-range';
import Paragraph from './paragraph';
import { computed } from '@ember/object';
import { fmt, hash, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import BlobFile from '@intercom/embercom-composer/lib/blob-file';
import fetchImage from '@intercom/embercom-composer/lib/fetch-image';
import AlignableBlock from './mixins/alignable-block';
import loadImage from 'load-image';
import { alias, and, not, notEmpty } from '@ember/object/computed';
import { bind } from '@ember/runloop';
import Em from 'ember';
export default FileBlock.extend(AlignableBlock, {
  isMedia: true,
  isImage: true,
  isInline: true,
  type: 'image',
  fetchFile: fetchImage,
  width: null,
  height: null,
  hasWidthAndHeight: and('width', 'height'),
  hasEditor: not('hasUploadError'),
  linkUrl: null,
  escapedUrl: htmlEscape('url'),
  hasLinkUrl: notEmpty('linkUrl'),
  openingTag: openingTag('url', 'linkUrl', 'id', 'width', 'height', 'hasUploadError', 'isUploading', 'hasNoFile', 'align'),
  closingTag: '</ic-block>',
  serialized: Em.computed('url', 'linkUrl', 'width', 'height', 'align', 'type', 'allowAlignment', 'isUploadingOrHasUploadError', function () {
    if (this.get('isUploadingOrHasUploadError')) {
      return null;
    }
    let serialized = {
      type: this.get('type'),
      url: this.get('url'),
      width: this.get('width'),
      height: this.get('height')
    };
    if (this.get('hasLinkUrl')) {
      serialized.linkUrl = this.get('linkUrl');
    }
    if (this.get('config.allowAlignment')) {
      serialized.align = this.get('align');
    }
    return serialized;
  }),
  dimensions: computed('width', 'height', function () {
    return `${this.width}x${this.height}`;
  }),
  uploadAttributes: hash('dimensions'),
  innerHtml: Em.computed('_zeroWidthSpace', '_paragraphInserter', 'uploadStatusHtml', 'escapedUrl', function () {
    if (this.get('escapedUrl')) {
      return `${this.get('_zeroWidthSpace')}${this.get('_paragraphInserter')}<span contenteditable="false" class="block-image-container">${this.get('uploadStatusHtml')}<img class="block-image" src="${this.get('escapedUrl')}" /></span>${this.get('_paragraphInserter')}${this.get('_zeroWidthSpace')}`;
    }
    return '';
  }),
  uploadProgressHtml: '<div contenteditable="false" class="composer-file-uploadstatus"><div class="composer-file-uploadstatus-inner">Uploading...</div></div>',
  uploadErrorHtml: fmt('<div contenteditable="false" class="composer-file-uploadstatus">' + '<div class="composer-file-uploadstatus-inner">' + '<div class="composer-file-error"><i class="composer-file-alert i o__24 o__alert"></i><span class="composer-file-error-message">Your image couldn\'t be uploaded</span></div>' + '<a href="#" class="composer-upload-retry" data-block-id="%@"class="composer-upload-retry">Try again</a>' + '</div>' + '</div>', 'id'),
  uploadTooLargeHtml: fmt('<div contenteditable="false" class="composer-file-uploadstatus">' + '<div class="composer-file-uploadstatus-inner">' + '<div class="composer-file-error"><i class="composer-file-alert i o__24 o__alert"></i><span class="composer-file-error-message">%@</span></div>' + '</div>' + '</div>', 'errorMessage'),
  cleanData() {
    //TODO: GJ: tests
    this.cleanUrl('linkUrl');
  },
  blockUrl: alias('linkUrl'),
  join(blockToJoinWith) {
    let blocksToRemove = [];
    if (blockToJoinWith.get('type') === 'paragraph' && blockToJoinWith.get('text.length') === 0) {
      blocksToRemove.pushObject(blockToJoinWith);
    }
    return BlockMutationResult.create({
      blockRange: BlockRange.atPositionIndex(0),
      blocksToRemove
    });
  },
  backspace() {
    return BlockMutationResult.create({
      blocksToRemove: [this],
      blockRange: BlockRange.atPositionIndex(0)
    });
  },
  split() {
    return Paragraph.create({
      config: this.get('config')
    });
  },
  calculateDimensions: Em.on('init', Em.observer({
    dependentKeys: ['url'],
    fn() {
      if (this.get('url') && !this.get('hasWidthAndHeight')) {
        fetchImage(this.get('url')).then(function success(image) {
          this.setProperties({
            width: image.width,
            height: image.height
          });
        }.bind(this), function failure() {
          this.setProperties({
            hasUploadError: true,
            width: 0,
            height: 0
          });
        }.bind(this));
      }
    },
    sync: true
  })),
  preprocess() {
    return new Em.RSVP.Promise(function (resolve, reject) {
      this._super().then(this.getTempUrl.bind(this), reject).then(this.rotateImage.bind(this), reject).then(this.getTempUrl.bind(this), reject).then(resolve, reject);
    }.bind(this));
  },
  rotateImage() {
    return new Em.RSVP.Promise(function (resolve) {
      let originalFile = this.get('file');
      let gotBlob = function (blob) {
        blob.name = originalFile.name;
        this.set('file', blob);
        resolve();
      }.bind(this);
      let gotOrientation = function (canvas) {
        canvas.toBlob(gotBlob);
      };
      let gotMetaData = function (data) {
        if (data.exif) {
          let orientation = data.exif[0x0112];
          if (orientation !== undefined && orientation !== 1) {
            loadImage(originalFile, gotOrientation, {
              orientation: true,
              canvas: true
            });
            return;
          }
        }
        resolve();
      };
      loadImage.parseMetaData(originalFile, gotMetaData);
    }.bind(this));
  },
  getTempUrl() {
    return new Em.RSVP.Promise(function (resolve, reject) {
      let img = BlobFile.createImage(this.get('file'));
      img.onload = bind(this, function () {
        this.setProperties({
          url: img.src,
          width: img.width,
          height: img.height
        });
        this.get('uploadManager').doRender();
        resolve();
      });
      img.onerror = function () {
        this.set('hasUploadError', true);
        reject();
      }.bind(this);
    }.bind(this));
  }
});